import React, { useEffect, useState } from "react";

import { ControlGroup, MenuItem, Tag } from "@blueprintjs/core";
import { MultiSelect } from "@blueprintjs/select";

import { authenticatedGetFetch } from "../../utils/AuthenticatedFetch";

export function methodTag(method) {
    switch (method) {
      case "GET":
        return <Tag intent="success">{method}</Tag>;
      case "POST":
        return <Tag intent="primary">{method}</Tag>;
      case "PUT":
        return <Tag intent="warning">{method}</Tag>;
      case "DELETE":
        return <Tag intent="danger">{method}</Tag>;
      default:
        return <Tag intent="success">{method}</Tag>;
    }
  }

export function MultiRouteSelect(props) {
  const [routeList, setRouteList] = useState([]);
  const [routes, _setRoutes] = useState([]);
  const [route, setRoute] = useState(routeList[0]);

  function setRoutes(routes) {
    _setRoutes(routes);
    if (props.onSelect !== undefined) props.onSelect(routes);
  }

  useEffect(() => {
    authenticatedGetFetch("/routes", (response) => setRouteList(response));
  }, []);

  return (
    <ControlGroup fill={true}>
      <MultiSelect
        activeItem={route}
        items={routeList}
        selectedItems={routes}
        itemRenderer={(val, itemProps) => {
          if (routes.includes(val)) return null; // hide already selected routes
          else
            return (
              <MenuItem
                text={val.method + val.path}
                key={val.method + val.path}
                label={methodTag(val.method)}
                onClick={(elm) => {
                  if (routes.includes(val.pk)) {
                    setRoutes(routes.filter((filtre) => filtre !== val.pk));
                  } else {
                    setRoute(val.pk);
                    setRoutes([...routes, val]);
                  }
                }}
                selected={routes.includes(val.pk)}
              />
            );
        }}
        itemListPredicate={(query, items) => {
          return items.filter((filtre) =>
            filtre?.path?.toLowerCase().includes(query?.toLowerCase())
          );
        }}
        onItemSelect={() => {}}
        tagRenderer={(r) =>
          <span>{methodTag(r.method)} {r.path}</span>
        }
        onRemove={(item) => {
          setRoutes(routes.filter((elm) => elm !== item));
        }}
        onClear={() => setRoutes([])}
      />
    </ControlGroup>
  );
}
